/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ProjectVersionsConfigProviderEntryEntrypointProps } from './ProjectVersionsConfigProviderEntry.entrypoint.types.tsx';

type ProjectVersionsConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	ProjectVersionsConfigProviderEntryEntrypointProps,
	{} | null
>;

export const projectVersionsConfigProviderEntrypoint: EntryPoint<
	ProjectVersionsConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<ProjectVersionsConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-project-versions-config-provider" */ './ProjectVersionsConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
